import React, { useEffect, useState } from "react";
import { Alert, CircularProgress, MenuItem, TextField } from "@mui/material";
import Swal from "sweetalert2";
import { updateClientPayDay } from "../gestionCarteraApi";
import { allowedPayDays } from "../gestionCarteraFormat";
import { COLORS, ModalShell, PrimaryButton, SecondaryButton } from "../gestionCarteraUi";

const currentPayDay = (credit) => Number(String(credit?.quotas?.[0]?.payDate || "").slice(8, 10)) || 1;

const wasAlreadyUpdated = (credit) => (credit?.quotas || []).some((quota) => quota.updatePayDate != null);

/**
 * Cambia el día de pago con el endpoint REAL por cliente (decisión de producto).
 * Si el cliente tiene varios créditos activos, backend decide cuál actualiza: se avisa al usuario.
 */
export default function CambiarDiaPagoModal({ open, credit, clientUuid, activeCreditsCount, onClose, onDone }) {
  const [day, setDay] = useState("");
  const [saving, setSaving] = useState(false);
  const currentDay = currentPayDay(credit);
  const alreadyUpdated = wasAlreadyUpdated(credit);

  useEffect(() => {
    if (open) setDay("");
  }, [open]);

  const handleSubmit = async () => {
    setSaving(true);
    try {
      await updateClientPayDay(clientUuid, day);
      setSaving(false);
      onDone();
      Swal.fire({ icon: "success", title: "Día de pago actualizado", text: "Se actualizaron las fechas de pago de las cuotas.", confirmButtonColor: COLORS.primary });
    } catch (error) {
      setSaving(false);
      Swal.fire({ icon: "error", title: "Error", text: "Error en la actualización de las fechas de pago de las cuotas.", confirmButtonColor: COLORS.primary });
    }
  };

  return (
    <ModalShell
      open={open}
      onClose={saving ? undefined : onClose}
      title="Cambiar día de pago"
      subtitle={credit ? `Crédito ${credit.oldId}` : ""}
      actions={
        <>
          <SecondaryButton onClick={onClose} disabled={saving}>Cancelar</SecondaryButton>
          <PrimaryButton
            onClick={handleSubmit}
            disabled={alreadyUpdated || saving || !day}
            startIcon={saving ? <CircularProgress size={16} color="inherit" /> : null}
          >
            Actualizar
          </PrimaryButton>
        </>
      }
    >
      {alreadyUpdated ? (
        <Alert severity="warning">No se permite actualizar las fechas de pago más de una vez.</Alert>
      ) : (
        <>
          {activeCreditsCount > 1 && (
            <Alert severity="info">
              El cliente tiene {activeCreditsCount} créditos activos. Este cambio se aplica a nivel cliente y el
              sistema define cuál de sus créditos se actualiza.
            </Alert>
          )}
          <TextField label="Día de pago actual del crédito" value={currentDay} disabled />
          <TextField select label="Nuevo día de pago" value={day} onChange={(event) => setDay(event.target.value)}>
            {allowedPayDays(currentDay).map((option) => <MenuItem key={option} value={option}>{option}</MenuItem>)}
          </TextField>
        </>
      )}
    </ModalShell>
  );
}
